import { Component, EventEmitter, Input, Output, } from '@angular/core';

/**
 * Generated class for the RmtNotifyBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-notify-bar',
  templateUrl: 'rmt-notify-bar.html'
})
export class RmtNotifyBarComponent {
  // IMPROVE: later use this component for different alerts (i.e with red and green colors)
  @Input() barTitle: string;
  @Input() actionButtonText: string;
  @Input() notifyBarType: NotifyBarType;
  @Output() userTap = new EventEmitter<any>();
  
  ngOnInit() {
    if (!this.notifyBarType) {
      this.notifyBarType = NotifyBarType.alert;
    }
  }

  userBarTap(ev) {
    this.userTap.emit(ev);
  }

}

enum NotifyBarType {
  alert = 'alert',
  info = 'info'
}


// WEBPACK FOOTER //
// ./src/components/rmt-notify-bar/rmt-notify-bar.ts